<template>
  <div id="app">
    <div v-if="loading">
      <Loader :is-global="false" :active="true"></Loader>
    </div>

    <Slingshot v-else :payload="payload"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Loader } from '@unbabel/ui'
import Slingshot from '@/components/Slingshot'

export default {
  name: 'App',
  props: ['controllerType'],
  data: function () {
    return {
      loading: true,
      payload: {}
    }
  },
  mounted: async function () {
    try {
      // Initialize Freshdesk API
      await this.initializeClient(this.controllerType)
      // Initialize Messages API
      await this.initializeAPI()
      // Get agent/organization and ticket
      await this.fetchAgent()
      // Get first comment from freshdesk ticket
      const payload = await this.fetchPayloadForFirstMessage()

      this.payload = payload.message
      this.loading = false
    } catch (err) {
      this.loading = false
    }
  },
  components: {
    Slingshot,
    Loader
  },
  methods: {
    ...mapActions([
      'initializeClient',
      'fetchPayloadForFirstMessage',
      'initializeAPI',
      'fetchAgent',
      'fetchThreadAndFirstMessage'
    ])
  },
  computed: {
    ...mapGetters([
      'agent',
      'thread'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue